<template>
  <div ref="chatQaOperator" class="vhsaas-chat-operator">
    <div class="vhsaas-chat-operator__header-wrapper">
      <i class="vh-iconfont vh-line-expression" @click.stop="toggleEmoji"></i>
      <div class="qa-recommend" v-if="qaServerState.recommendList.length > 0">
        <i class="vh-saas-iconfont vh-saas-line-tuijian" @click="showRecommend"></i>
        <section class="qa-recommend-list" v-if="isShowRecommend">
          <h3 class="title">
            {{ $t('chat.chat_1104') }}
            <i class="vh-iconfont vh-line-close" @click="isShowRecommend = false"></i>
          </h3>
          <div class="container-data">
            <ul>
              <li v-for="(item, index) in recommendList" :key="index">
                <div class="data-text">
                  <span class="data-text_circle">
                    <i class="num"></i>
                  </span>
                  <div class="data-text_title">
                    <div class="data-text_title_basebg">
                      <div>
                        <span class="label">{{ $t('chat.chat_1040') }}：</span>
                        {{ item.content }}
                      </div>
                      <div v-for="(ans, i) in item.answer" :key="ans.id">
                        <span class="label ans">
                          {{ $t('chat.chat_1041') }}{{ item.answer.length > 1 ? i + 1 : '' }}：
                        </span>
                        {{ ans.content }}
                      </div>
                      <div class="data-time">
                        {{ item.created_at ? item.created_at.substr(5, 11) : '' }}
                      </div>
                    </div>
                  </div>
                </div>
              </li>
            </ul>
          </div>
        </section>
      </div>

      <div class="vhsaas-chat-operator__only-mine" v-if="!hideMine" v-clickoutside="hideQaFilter">
        <i class="vh-saas-iconfont vh-saas-line-setting" @click="isQaFilter = true"></i>
        <section class="qa-set-dialog" v-show="isQaFilter">
          <vh-checkbox
            class="only-me-item__checkbox"
            @change="onClickOnlyMine"
            v-model="onlyMine"
          ></vh-checkbox>
          <span class="only-me-item__label">{{ $t('chat.chat_1018') }}</span>
        </section>
      </div>
      <!-- 表情选择 -->
      <div class="vhsaas-chat-operator__emoji-wrapper">
        <emoji ref="emoji" @emojiInput="emojiInput"></emoji>
      </div>
    </div>
    <div class="vhsaas-chat-qa-operator__body-wrap">
      <div
        v-show="!inputStatus.disable && !chatLoginStatus"
        class="vhsaas-chat-operator__textarea-box"
      >
        <textarea
          id="qa-textarea"
          ref="chatQaTextarea"
          v-model="inputValue"
          :placeholder="inputStatus.placeholder"
          rows="1"
          class="vhsaas-chat-operator__textarea"
          @input="inputHandle"
          @keydown.stop="onkeydownHandle($event)"
          @keyup.stop="onKeyUpHandle($event)"
        ></textarea>
        <span v-show="showWordLimit" class="vhsaas-chat-operator__textarea-show-limit">
          <i
            class="textarea-show-limit__current-count"
            :class="{ limited: inputValue.length >= 140 }"
          >
            {{ inputValue.length }}
          </i>
          /
          <i class="textarea-show-limit__total">140</i>
        </span>
      </div>
      <div
        v-show="inputStatus.disable || chatLoginStatus"
        class="vhsaas-chat-operator__textarea-placeholder"
      >
        <!--TODO待翻译-->
        <span v-show="chatLoginStatus" class="textarea-placeholder_no-login">
          <span v-if="embedNotIframe">
            {{ $t('login.login_1007') }}
          </span>
          <span v-else class="chat-login-btn" @click="loginVisible">
            {{ $t('chat.chat_1021') }}
          </span>
        </span>
        <span
          v-show="inputStatus.disable && !chatLoginStatus"
          class="textarea-placeholder_no-login"
        >
          {{ inputStatus.placeholder }}
        </span>
      </div>
      <div class="vhsaas-chat-operator__send-btn-box">
        <div
          class="vhsaas-chat-operator__send-btn"
          :class="{ disable: inputStatus.disable }"
          :disabled="inputStatus.disable"
          @click="sendMessage"
        >
          <i class="vh-iconfont vh-line-send"></i>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
  import OverlayScrollbars from 'overlayscrollbars';
  import Emoji from '@/packages/chat/src/common/components/emoji';
  import { useQaServer, useRoomBaseServer } from 'middle-domain';
  import { escapeHtml } from '@/app-shared/utils/tool';
  import { inIframe } from '@/app-shared/utils/common';
  export default {
    components: {
      Emoji
    },
    props: {
      chatLoginStatus: {
        type: Boolean,
        required: true
      },
      chatList: {
        type: Array,
        required: true,
        default: () => []
      },
      inputStatus: {
        required: true,
        type: Object,
        default: () => ({
          disable: false,
          noLogin: false,
          placeholder: this.$t('host.k_598001')
        })
      }
    },
    data() {
      return {
        inputValue: '',
        showWordLimit: false,
        overlayScrollbar: null, // 滚动条实例
        onlyMine: false,
        questionGap: 0, // 每次发送问答成功以后需要等待15秒才能再此发送问答
        //限频定时器
        questionGapInterval: null,
        isQaFilter: false,
        isShowRecommend: false,
        qaServerState: useQaServer().state
      };
    },
    computed: {
      join_name() {
        return this.watchInitData.join_info.nickname;
      },
      roleName() {
        return this.watchInitData.join_info.role_name;
      },
      roomId() {
        return this.watchInitData.interact.room_id;
      },
      //黄金链路配置
      configList() {
        return this.$domainStore.state.roomBaseServer.configList;
      },
      //隐藏 只看我的
      hideMine() {
        return this.configList['ui.qa_just_look_mine'] === 0;
      },
      recommendList() {
        return this.qaServerState.recommendList.filter(el => {
          return !el.isMsg;
        });
      },

      //嵌入但非iframe
      embedNotIframe() {
        return this.$domainStore.state.roomBaseServer.embedObj.embed && !inIframe;
      }
    },
    watch: {
      inputValue: {
        handler(newValue) {
          // 注意事项：输入了三行文字，直接Backspace 退格，重置输入框高度
          if (!newValue) {
            // console.log('chat input 值发生变化了', newValue);
            // 输入框内容发生变化，更新滚动条
            this.$nextTick(() => {
              this.overlayScrollbar.update();
              this.inputHandle();
            });
          }
        }
      },
      'qaServerState.recommendList': function (val) {
        if (val.length == 0) {
          this.isShowRecommend = false;
        }
      }
    },
    mounted() {
      this.overlayScrollbarInit();
      this.watchInitData = useRoomBaseServer().state.watchInitData;
      document.addEventListener('click', () => {
        this.isFilterShow = false;
      });
    },
    methods: {
      hideQaFilter() {
        this.isQaFilter = false;
      },
      //阻止输入框空格按键事件冒泡，触发播放器暂停/播放
      onKeyUpHandle(event) {
        event.stopPropagation();
      },
      // 滚动条初始化
      overlayScrollbarInit() {
        this.$nextTick(() => {
          this.overlayScrollbar = OverlayScrollbars(document.getElementById('qa-textarea'), {
            paddingAbsolute: true,
            className: 'os-theme-light os-theme-vhall',
            scrollbars: {
              autoHide: 'leave',
              autoHideDelay: 200
            }
          });
        });
      },
      // 输入框 input 事件
      inputHandle() {
        // const chatOldTextareaHeight = this.$refs.chatQaTextarea.style.height;
        // 最大字数限制 140
        if (this.inputValue.length > 140) {
          this.inputValue = this.inputValue.substring(0, 140);
        }
        this.$nextTick(() => {
          const chatTextareaHeight = this.$refs.chatQaTextarea.style.height;
          console.log('chatTextareaHeight', chatTextareaHeight);
          // if (chatOldTextareaHeight !== chatTextareaHeight) {
          const hostTextarea = document.querySelector(
            '.vhsaas-chat-qa-operator__body-wrap .os-host-textarea'
          );
          const chatTextAreaHeight = parseInt(chatTextareaHeight);
          if (chatTextAreaHeight <= 60) {
            // 解决删除文本之后 textarea 高度不会自动减小的问题
            this.$refs.chatQaTextarea.style.minHeight = '20px';
            hostTextarea.style.minHeight = chatTextareaHeight;
          } else {
            hostTextarea.style.minHeight = '59px';
          }
          // 三行的时候显示字数限制，否则不显示
          this.showWordLimit = chatTextAreaHeight > 40;

          // 触发父元素绑定的高度发生变化事件
          setTimeout(() => {
            this.$emit('chatTextareaHeightChange', this.$refs.chatQaOperator.offsetHeight);
          });
          // }
        });
      },
      // 登录
      loginVisible() {
        this.$emit('needLogin');
      },
      // 切换表情显示
      toggleEmoji() {
        if (this.chatLoginStatus) {
          // this.$message({
          //   message: this.$t('未登录'),
          //   showClose: true,
          //   // duration: 0,
          //   type: 'error',
          //   customClass: 'zdy-info-box'
          // })
          this.toggleEmoji();
          return;
        }

        if (this.inputStatus.disable) {
          this.$message({
            message: this.$t('chat.chat_1006'),
            showClose: true,
            // duration: 0,
            type: 'error',
            customClass: 'zdy-info-box'
          });
          return;
        }
        this.$refs.emoji.toggleShow();
      },
      // 子组件输入表情
      emojiInput(value) {
        if (this.inputStatus.disable) {
          return;
        }
        this.inputValue += value;
      },
      // 问答只看我的点击事件
      onClickOnlyMine(value) {
        this.onlyMine = value;
        if (this.onlyMine) {
          this.$message({
            message: this.$t('chat.chat_1019'),
            showClose: true,
            // duration: 0,
            type: 'success',
            customClass: 'zdy-info-box'
          });
        } else {
          this.$message({
            message: this.$t('chat.chat_1020'),
            showClose: true,
            // duration: 0,
            type: 'success',
            customClass: 'zdy-info-box'
          });
        }
        this.$emit('onOnlyMine', this.onlyMine);
      },
      onkeydownHandle(event) {
        if (event.keyCode == 13) {
          this.sendMessage();
          event.preventDefault();
        }
      },
      //发送消息
      async sendMessage() {
        if (this.inputStatus.disable) {
          return;
        }
        // 数据埋点
        window.vhallReportForWatch?.report(170027, {
          is_empty: this.inputValue.trim() ? 0 : 1
        });
        if (this.inputValue.trim() === '') {
          return this.$message({
            message: this.$t('chat.chat_1009'),
            showClose: true,
            // duration: 0,
            type: 'error',
            customClass: 'zdy-info-box'
          });
        }
        if (this.questionGap > 0) {
          this.lock = sessionStorage.getItem('QALock');
          if (this.lock && this.lock == 'true') {
            this.$emit('onInputStatus', this.$t('chat.chat_1080', { n: this.questionGap }));
          } else {
            this.$emit('onInputStatus', this.$t('chat.chat_1003'));
          }
        } else {
          console.warn('获取发送问答--------');
          const params = {
            room_id: this.roomId,
            content: escapeHtml(this.inputValue)
          };
          // 如果是回放，需要传回放id
          if (this.watchInitData.webinar.type == 5 && this.watchInitData.switch.switch_id) {
            params.webinar_switch_id = this.watchInitData.switch.switch_id;
          }
          useQaServer()
            .sendQaMsg(params)
            .then(res => {
              console.warn('获取发送问答-----成功---', res);
              this.lock = sessionStorage.getItem('QALock');
              this.questionGap = 15;
              if (!this.questionGapInterval) {
                this.questionGapInterval = window.setInterval(() => {
                  if (this.questionGap > 0) {
                    if (!this.lock || this.lock == 'false') {
                      sessionStorage.setItem('QALock', true);
                    } else {
                      // this.inputStatus.placeholder = `太频繁啦，还有${this.questionGap}秒后才能发送`;
                      this.$emit(
                        'onInputStatus',
                        this.$t('chat.chat_1080', { n: this.questionGap })
                      );
                    }
                    this.questionGap = this.questionGap - 1;
                  } else {
                    window.clearInterval(this.questionGapInterval);
                    this.questionGapInterval = null;
                    // this.inputStatus.placeholder = '说点什么吧';
                    this.$emit(
                      'onInputStatus',
                      this.inputStatus.disable
                        ? this.$t('chat.chat_1079')
                        : this.$t('chat.chat_1003')
                    );
                    sessionStorage.setItem('QALock', false);
                  }
                }, 1000);
              }
              window.VhallDataAgent.track('chat_send', {
                chat_type: 'ques'
              });
            })
            .catch(res => {
              this.$message({
                message: this.$tec(res.code) || this.$t('chat.chat_1056'),
                showClose: true,
                // duration: 0,
                type: 'error',
                customClass: 'zdy-info-box'
              });
            });
        }
        // 这块看起来很奇怪的代码，是为了清空输入框内容之后自适应高度。
        // 没有更好的替换方案，误删！
        this.inputValue = '';

        this.$nextTick(() => {
          // 输入框内容发生变化，更新滚动条
          this.overlayScrollbar.update();
          this.inputHandle();
        });
        // setTimeout(() => {
        //   this.inputValue = '';
        //   // this.$emit('performScroll');
        // });
      },
      showRecommend() {
        useQaServer().getQARecommendList();
        this.isShowRecommend = true;
      }
    }
  };
</script>

<style lang="less">
  @font-dark-qa-second: #666666;
  .vhsaas-chat-operator {
    width: calc(100% - 48px);
    padding: 10px 24px;
    border-top: 1px solid var(--tab-menu-bg-border);
    background-color: var(--chat-background-color-base);
    position: absolute;
    bottom: 0;
  }
  .vhsaas-chat-operator__header-wrapper {
    height: 19px;
    margin-bottom: 9px;
    line-height: 19px;
    // position: relative;
    .vh-line-expression {
      cursor: pointer;
      font-size: 18px;
      color: #999999;
      &:hover {
        color: var(--theme-color);
      }
    }
    .vh-saas-iconfont,
    .vh-iconfont {
      margin-right: 13px;
      color: #999;
      font-size: 18px;
      cursor: pointer;
      &:hover {
        color: var(--theme-color);
      }
    }
    .vhsaas-chat-operator__only-mine {
      display: inline-flex;
      align-items: center;
      vertical-align: top;
      line-height: 18px;
      position: relative;
      i {
        color: #999;
      }
      .vh-saas-iconfont {
        cursor: pointer;
        &:hover {
          color: var(--theme-color);
        }
      }
      .qa-set-dialog {
        white-space: nowrap;
        position: absolute;
        width: auto;
        padding: 10px;
        background-color: var(--header-tab-item-dropdown-color);
        box-shadow: 0 6px 12px 0 rgba(0, 0, 0, 0.08), 0 2px 4px 0 rgba(0, 0, 0, 0.02);
        border-radius: 4px;
        position: absolute;
        top: -11px;
        left: 15px;
        transform: translateY(-100%);
      }

      .only-me-item__label {
        // margin-left: 5px;
        font-size: 14px;
        line-height: 18px;
        color: var(--theme-tab-content-qa-onlyMe-font);
      }
    }
  }
  .only-me-item__checkbox {
    display: inline-block;
    margin-right: 5px !important;
    position: relative;
    color: #999999;
    cursor: pointer;
    font-size: 14px;
    .vh-checkbox__inner {
      background-color: transparent;
      border: 1px solid #999;
    }
    &.iconfuxuankuang_yixuan {
      color: @font-error;
      &:before {
        position: relative;
        z-index: 1;
      }
      &:after {
        content: '';
        position: absolute;
        top: 4px;
        left: 1px;
        width: 12px;
        height: 12px;
        z-index: 0;
        background-color: #ffffff;
      }
    }
  }
  .vhsaas-chat-operator__emoji-wrapper {
    width: 278px;
    position: absolute;
    top: -14px;
    transform: translateY(-100%);
    border-radius: 4px;
    @media screen and (max-width: 1280px) {
      max-height: 106px;
      overflow-y: auto;
    }
  }
  .vhsaas-chat-qa-operator__body-wrap {
    display: flex;
    justify-content: space-between;
    align-items: flex-end;
    .vhsaas-chat-operator__textarea-box {
      width: 240px;
      background-color: var(--chat-background-color-input);
      font-size: 14px;
      font-weight: 400;
      color: var(--chat-font-color-input);
      line-height: 20px;
      padding: 10px 12px;
      text-align: left;
      border-radius: 20px;
      position: relative;
      ::v-deep > .vhsaas-chat-operator__textarea.os-host-overflow {
        overflow: visible !important;
      }
      ::v-deep .os-scrollbar-vertical {
        right: -8px;
      }
      ::v-deep .os-host-textarea {
        min-height: 20px;
      }
      textarea.vhsaas-chat-operator__textarea {
        &::-webkit-input-placeholder {
          color: @font-dark-qa-second;
        }
        &:-moz-placeholder {
          color: @font-dark-qa-second;
        }
        &::-moz-placeholder {
          color: @font-dark-qa-second;
        }
        &:-ms-input-placeholder {
          color: @font-dark-qa-second;
        }
      }
      .vhsaas-chat-operator__textarea-show-limit {
        font-size: 12px;
        line-height: 20px;
        position: absolute;
        bottom: 9px;
        right: 14px;
        background-color: @bg-dark-normal;
        .textarea-show-limit__current-count {
          color: @font-link;
          &.limited {
            color: @font-error;
          }
        }
        .textarea-show-limit__total {
          color: @font-dark-normal;
        }
      }
    }
    .vhsaas-chat-operator__textarea-placeholder {
      width: 240px;
      background-color: var(--chat-background-color-input);
      font-size: 14px;
      font-weight: 400;
      color: @font-dark-normal;
      line-height: 20px;
      padding: 10px 12px;
      text-align: left;
      border-radius: 20px;
      .textarea-placeholder_no-login {
        color: #666666;
        cursor: default;
      }
      .chat-login-btn {
        cursor: pointer;
        color: @font-link;
      }
    }
    .vhsaas-chat-operator__send-btn-box {
      .vhsaas-chat-operator__send-btn {
        width: 40px;
        height: 40px;
        border-radius: 20px;
        background-color: var(--chat-background-color-input);
        display: flex;
        justify-content: center;
        align-items: center;
        cursor: pointer;
        .vh-line-send {
          font-size: 18px;
          color: var(--chat-font-color-msg-nickname);
        }
        &.disable {
          cursor: default;
          .vh-line-send {
            color: #666666;
          }
        }
      }
    }
  }
  .qa-recommend {
    display: inline-block;
    .qa-recommend-list {
      z-index: 10;
      max-height: 287px;
      position: absolute;
      left: 0;
      right: 0;
      bottom: 100%;
      background: #f7f7f9;
      border-radius: 8px;
      box-shadow: 0px -2px 10px 0px #0000001a;
      display: flex;
      flex-direction: column;
      padding-bottom: 20px;
      .title {
        height: 56px;
        line-height: 56px;
        text-align: center;
        color: #262626;
        font-size: 18px;
        font-weight: 600;
        i {
          position: absolute;
          right: 0;
          font-size: 14px;
        }
      }
    }
  }
</style>
<style lang="less" scoped>
  .container-data {
    padding: 0 20px;
    position: relative;
    overflow: auto;
    z-index: 2;
    flex: 1;
    ul {
      li {
        color: #262626;
        font-size: 14px;
        line-height: 1.2;
        position: relative;
      }
    }
    .data-time {
      line-height: 1.6;
      font-size: 14px;
      display: inline-block;
      text-align: left;
      color: #8c8c8c;
      padding-top: 10px;
    }
    .data-text {
      position: relative;
      padding-left: 6px;
      &_circle {
        display: flex;
        align-items: center;
        justify-content: center;
        width: 12px;
        height: 12px;
        border-radius: 50%;
        background: #fff;
        border: 1px solid var(--theme-color-main);
        top: 15px;
        left: 0px;
        position: absolute;
        .num {
          display: inline-block;
          width: 8px;
          height: 8px;
          border-radius: 50%;
          background: var(--theme-color-main);
        }
      }
      .col_bfb {
        background: #bfbfbf;
      }
      .border_col_bfb {
        border-color: #bfbfbf;
        background: #fff;
      }
      &_title {
        padding: 0 0 10px 16px;
        color: #1a1a1a;
        line-height: 1.6;
        word-break: break-word;
        border-left: 1px dashed #bfbfbf;
        border-radius: 2px;
        font-size: 14px;
        .data-text_title_basebg {
          background: rgba(255, 255, 255, 0.6);
          border-radius: 8px;
          padding: 12px 15px 10px 12px;
          a {
            text-decoration: underline #0a7ff5 !important;
          }
          & > :first-child {
            line-height: 20px;
            font-size: 14px;
          }
          .label {
            color: #fc9600;
            &.ans {
              padding-left: 8px;
            }
          }
        }
      }
    }
  }
</style>
